import { executeContractRequest } from '@/api/contract-client';
import type { WordstatGateway } from '@/api/wordstat';
import type { ContractClient } from './index';
export function createBackendWordstat(client: ContractClient): WordstatGateway {
  return {
    options: (options) =>
      executeContractRequest(client.GET('/api/v1/wordstat/options', { signal: options?.signal })),
    list: (params = {}, options) =>
      executeContractRequest(
        client.GET('/api/v1/wordstat-reports', {
          params: { query: params },
          signal: options?.signal,
        }),
      ),
    get: (id, options) =>
      executeContractRequest(
        client.GET('/api/v1/wordstat-reports/{report_id}', {
          params: { path: { report_id: id } },
          signal: options?.signal,
        }),
      ),
    create: (input) =>
      executeContractRequest(client.POST('/api/v1/wordstat-reports', { body: input })),
    update: (id, input) =>
      executeContractRequest(
        client.PATCH('/api/v1/wordstat-reports/{report_id}', {
          params: { path: { report_id: id } },
          body: input,
        }),
      ),
    remove: (id) =>
      executeContractRequest(
        client.DELETE('/api/v1/wordstat-reports/{report_id}', {
          params: { path: { report_id: id } },
        }),
      ),
    preview: (id) =>
      executeContractRequest(
        client.GET('/api/v1/wordstat-reports/{report_id}/preview', {
          params: { path: { report_id: id } },
        }),
      ),
    start: (id, fingerprint) =>
      executeContractRequest(
        client.POST('/api/v1/wordstat-reports/{report_id}/start', {
          params: { path: { report_id: id } },
          body: { preview_fingerprint: fingerprint },
        }),
      ),
    jobs: (id, params = {}, options) =>
      executeContractRequest(
        client.GET('/api/v1/wordstat-reports/{report_id}/jobs', {
          params: { path: { report_id: id }, query: params },
          signal: options?.signal,
        }),
      ),
    job: (id, jobId, options) =>
      executeContractRequest(
        client.GET('/api/v1/wordstat-reports/{report_id}/jobs/{job_id}', {
          params: { path: { report_id: id, job_id: jobId } },
          signal: options?.signal,
        }),
      ),
    phrases: (id, jobId, kind, params = {}, options) =>
      executeContractRequest(
        client.GET('/api/v1/wordstat-reports/{report_id}/jobs/{job_id}/phrases', {
          params: { path: { report_id: id, job_id: jobId }, query: { ...params, kind } },
          signal: options?.signal,
        }),
      ),
    dynamics: (id, jobId, options) =>
      executeContractRequest(
        client.GET('/api/v1/wordstat-reports/{report_id}/jobs/{job_id}/dynamics', {
          params: { path: { report_id: id, job_id: jobId } },
          signal: options?.signal,
        }),
      ),
  };
}
